// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@500;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  font-family: "Inter", sans-serif;
}

.order-summary {
  margin-top: 20px;
}

.total-price {
  padding-top: 40px;
}

.order-summary-header {
  padding-left: 20px;
}

.coupon-code {
  margin-top: 10rem;
  font-family: "Inter", sans-serif;
}

.total-price {
  font-family: "Inter", sans-serif;
  font: 100;
  font-weight: 600;
}

.apply-coupon-button {
  margin-top: 100px;
}

.product {
  width: 360px;
}

.mobile-button-container{
  position: fixed;
  bottom: 10px;
}

@media screen and (max-width: 680px) {
  .paymentName {
    display: none;
  }
  .order-summary {
    margin: 0px;
  }

  .product-table {
    box-shadow: none !important;
  }

  .desktop-view-container {
    display: none;
  }

}

@media screen and (min-width: 680px) {
  .mobile-button-container {
    display: none;
  
  }

  body {
    overflow: hidden;
    height: 100vh;
  }
}




/* Payment*/

/* Show both components by default */
.order-summary-container,
.payment-methods-container {
  display: block;
}

/* Media query for mobile view */
@media (max-width: 767px) {
  .hide-payment-methods {
    display: none;
  }

  .show-payment-methods {
    display: block;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/styles/style.css"],"names":[],"mappings":"AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;EAChC,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,WAAW;EACb;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,aAAa;EACf;;AAEF;;AAEA;EACE;IACE,aAAa;;EAEf;;EAEA;IACE,gBAAgB;IAChB,aAAa;EACf;AACF;;;;;AAKA,WAAW;;AAEX,oCAAoC;AACpC;;EAEE,cAAc;AAChB;;AAEA,gCAAgC;AAChC;EACE;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;AACF","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Inter:wght@500;700&display=swap\");\n\n* {\n  font-family: \"Inter\", sans-serif;\n}\n\n.order-summary {\n  margin-top: 20px;\n}\n\n.total-price {\n  padding-top: 40px;\n}\n\n.order-summary-header {\n  padding-left: 20px;\n}\n\n.coupon-code {\n  margin-top: 10rem;\n  font-family: \"Inter\", sans-serif;\n}\n\n.total-price {\n  font-family: \"Inter\", sans-serif;\n  font: 100;\n  font-weight: 600;\n}\n\n.apply-coupon-button {\n  margin-top: 100px;\n}\n\n.product {\n  width: 360px;\n}\n\n.mobile-button-container{\n  position: fixed;\n  bottom: 10px;\n}\n\n@media screen and (max-width: 680px) {\n  .paymentName {\n    display: none;\n  }\n  .order-summary {\n    margin: 0px;\n  }\n\n  .product-table {\n    box-shadow: none !important;\n  }\n\n  .desktop-view-container {\n    display: none;\n  }\n\n}\n\n@media screen and (min-width: 680px) {\n  .mobile-button-container {\n    display: none;\n  \n  }\n\n  body {\n    overflow: hidden;\n    height: 100vh;\n  }\n}\n\n\n\n\n/* Payment*/\n\n/* Show both components by default */\n.order-summary-container,\n.payment-methods-container {\n  display: block;\n}\n\n/* Media query for mobile view */\n@media (max-width: 767px) {\n  .hide-payment-methods {\n    display: none;\n  }\n\n  .show-payment-methods {\n    display: block;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
